import { render, staticRenderFns } from "./achieveShop.vue?vue&type=template&id=2d617809&scoped=true"
import script from "./achieveShop.vue?vue&type=script&lang=js"
export * from "./achieveShop.vue?vue&type=script&lang=js"
import style0 from "./achieveShop.vue?vue&type=style&index=0&id=2d617809&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d617809",
  null
  
)

export default component.exports